import { render, staticRenderFns } from "./WaitTable.vue?vue&type=template&id=39f1c958&scoped=true"
import script from "./WaitTable.vue?vue&type=script&lang=js"
export * from "./WaitTable.vue?vue&type=script&lang=js"
import style0 from "./WaitTable.vue?vue&type=style&index=0&id=39f1c958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1c958",
  null
  
)

export default component.exports